import React from "react";
import { createPortal } from "react-dom";
import './StickyNotes.css';

const DeleteConfirmationModal = ({ show, onConfirm, onCancel, noteNumber }) => {
  if (!show) return null;

  return createPortal(
    <div className="confirmation-overlay">
      <div className="confirmation-modal">
        <div className="confirmation-header">
          <span className="confirmation-title">Confirmation</span>
          <button type="button" className="confirmation-close" onClick={onCancel}>&times;</button>
        </div>
        <div className="confirmation-body">
          Are you sure you want to delete <span className="confirmation-note-name"> {noteNumber}</span>?
        </div>
        <div className="confirmation-actions">
          <button type="button" className="btn-yes" onClick={onConfirm}>Yes</button>
          <button type="button" className="btn-no" onClick={onCancel}>No</button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DeleteConfirmationModal;
